import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react'
import OTPInput from 'src/component/OTPInput'
import SmallSpinner from 'src/component/SmallSpinner/SmallSpinner'

interface OTPStepProps {
    otp: string[];
    setOtp: (val: string[]) => void;
    handleSubmit: () => void;
    error: string | null;
    setVerifyError: (val: string | null) => void;
    isSubmitting: boolean;
}

const OTPStep = ({ otp, setOtp, handleSubmit, error, setVerifyError, isSubmitting }: OTPStepProps) => {
    const { t } = useTranslation()

    const handleChange = (val: string[]) => {
        setVerifyError(null)
        setOtp(val)
    }

    const handlePaste = async () => {
        try {
            const text = await navigator.clipboard.readText()
            const digits = text.replace(/\D/g, "").slice(0, otp.length)
            if (!digits) return
            const newOtp = Array(otp.length).fill("")
            digits.split("").forEach((d, i) => { newOtp[i] = d })
            setVerifyError(null)
            setOtp(newOtp)
        } catch {
            // clipboard access denied — user can type manually
        }
    }

    return (
        <>
            <div className="inputs-container">
                <OTPInput className={error ? "verify-error" : ""} value={otp} setValue={(val: string[]) => handleChange(val)} />
            </div>

            <button
                type="button"
                className="two-factor-copy-button"
                onClick={handlePaste}
            >
                <Icon icon="solar:copy-outline" width={18} /> {t("pasteCode")}
            </button>

            <button
                className="login-content-login-btn"
                onClick={handleSubmit}
                disabled={otp.some((d) => d === "")}
            >
                {isSubmitting ? <SmallSpinner className="fs-6" /> : t("login")}
            </button>
            <Link to="/login" className="loginLink">
                {t("goTologin")}
            </Link>
        </>
    )
}

export default OTPStep
